"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.content span.active-page-title {\n  line-height: 1.43; }\n\n.content .bx--grid.reset-spacings .bx--row div[class*='bx--col'].output {\n  padding: 0 16px; }\n\n.content.output {\n  padding: 0 16px; }\n\n.content.centered-title h1 {\n  text-align: center; }\n\n.content.centered-texts .output h1,\n.content.centered-texts .output h2,\n.content.centered-texts .output h3,\n.content.centered-texts .output > p {\n  text-align: center; }\n\n.content p {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.28572;\n  letter-spacing: 0.16px;\n  margin-bottom: 1.5rem;\n  line-height: 1.43; }\n  .content p.ghost {\n    font-size: 12px;\n    color: #a8a8a8; }\n  .content p.error {\n    color: #e41b13; }\n\n.content .large-up.active-page-title {\n  padding-top: 3px;\n  padding-right: 16px;\n  float: right; }\n\n.content .medium-down .active-page-title {\n  margin-bottom: 16px;\n  display: block; }\n";
  const fileName = "Content_Content";
  const element = document.querySelector("style[data-sass-component='Content_Content']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Content = props => {
  const classes = ['content', props.centeredTitle ? 'centered-title' : null, props.centeredTexts ? 'centered-texts' : null, props.className].filter(item => item).join(' ');
  if (props.width === 'full') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: [classes, 'output'].join(' ')
    }, props.children);
  }
  const createGridColumnClasses = () => {
    if (props.activePageTitle) {
      return {
        left: 'bx--col-lg-4 bx--col-md-1',
        middle: 'bx--col-lg-8 bx--col-md-6 bx--col-sm-4',
        right: 'bx--col-lg-4 bx--col-md-1'
      };
    }
    if (props.width === 'slim') {
      return {
        left: 'bx--col-lg-5 bx--col-md-2',
        middle: 'bx--col-lg-6 bx--col-md-4 bx--col-sm-4',
        right: 'bx--col-lg-5 bx--col-md-2'
      };
    }
    return {
      left: 'bx--col-lg-2',
      middle: 'bx--col-lg-12 bx--col-md-8 bx--col-sm-4',
      right: 'bx--col-lg-2'
    };
  };
  const gridColumnClasses = createGridColumnClasses();
  const renderActivePageTitle = className => {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: ['active-page-title', className].filter(item => item).join(' ')
    }, props.activePageTitle);
  };
  const renderRow = (className, leftContent, middleContent) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: ['bx--row', className].filter(item => item).join(' ')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: gridColumnClasses.left
    }, leftContent), /*#__PURE__*/_react.default.createElement("div", {
      className: [gridColumnClasses.middle, 'output'].join(' ')
    }, middleContent), /*#__PURE__*/_react.default.createElement("div", {
      className: gridColumnClasses.right
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--grid reset-spacings"
  }, props.activePageTitle && renderRow('medium-down', null, renderActivePageTitle()), renderRow(null, props.activePageTitle ? renderActivePageTitle('large-up') : null, props.children)));
};
Content.propTypes = {
  width: _propTypes.default.string,
  centeredTitle: _propTypes.default.bool,
  centeredTexts: _propTypes.default.bool,
  className: _propTypes.default.string,
  activePageTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
var _default = exports.default = Content;